<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>email_outline</mat-icon>
        <div>
          <span>Cartas Palestrantes • </span>
          <span>{{title}}&nbsp;</span>
        </div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <!--
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
          -->
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-tab-group style="margin-left: 10px;">

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
        <div style='color:rgb(43,54,123)'>Cartas</div>
      </ng-template>

        <!-- TABLE -->
        <mat-table class="mat-table-letter" [dataSource]="_letterSpeakersService.letterDataSource" matSort matSortDisableClear=true>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>mail_outline</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="letter-name">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style='display:flex; flex-direction:column;'>
                <div>{{ element.name }}</div>
                <div style='font-style: italic;'>
                  <div *ngIf='element.type=="0"'>Confirmação</div>
                  <div *ngIf='element.type=="1"'>Atualização</div>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- preview Column -->
          <ng-container matColumnDef="preview">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openPreviewDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-help'>preview
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openLetterDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>
              <a mat-button (click)="openLetterDialog(null)" style='width:60px;'>
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteLetter(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- Header -->
          <mat-header-row
            *matHeaderRowDef="_letterSpeakersService.letterDisplayedColumns; sticky: true;"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: _letterSpeakersService.letterDisplayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>forward_to_inbox</mat-icon>
        <div style='color:rgb(43,54,123)'>Convites</div>
      </ng-template>

      <mat-form-field style="width: 99%; margin-top: 10px;" appearance="outline">
        <mat-label>Cartas</mat-label>
        <mat-select (ngModelChange)='letterSpeakerSelectChange($event)' [(ngModel)]='letterSelected'>
          <mat-option *ngFor="let letter of _letterSpeakersService.letters" [value]="letter">
            <span>{{ letter.name }}</span>
            <span> - </span>
            <span *ngIf="letter.type=='0'"><i>Confirmação</i></span>
            <span *ngIf="letter.type=='1'"><i>Atualização</i></span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-table class="mat-table-invite" [dataSource]="_inviteSpeakersService.invitesDataSource" matSort matSortDisableClear=true>

        <!-- member Column -->
        <ng-container matColumnDef="staff_name">
          <mat-header-cell *matHeaderCellDef>
            Palestrantes
          </mat-header-cell>
          <mat-cell *matCellDef="let element">

            <div *ngIf='element.date_sent' style='padding-top: 10px;'>

              <a target='_blank' href={{element.url_back}}>
                <span style="color: black;">
                  {{ element.member_name }}
                </span>
              </a>

              <div style='padding: 5px;'>
                <span *ngIf="element.admin_invite">
                  <i>Convite via admin</i>
                </span>
                <span *ngIf="element.admin_response">
                  - <i>Resposta via admin</i>
                </span>
              </div>

            </div>

            <div *ngIf='!element.date_sent' style='padding-top: 10px;'>
              <div>
                {{ element.member_name }}
              </div>
              <div *ngIf='element.obs' style='padding: 10px 5px 0px 5px; margin-left: 60px;'>
                Obs: {{element.obs}}
              </div>
            </div>

          </mat-cell>
        </ng-container>

        <!-- confirm  Column -->
        <ng-container matColumnDef="confirm">
          <mat-header-cell *matHeaderCellDef>
            Confirmar
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngIf="element.requireConfirmAll" style="color: green;">(Confirmar)</span>
            <span *ngIf="!element.requireConfirmAll" style="color: red;">(Não confirmar)</span>
          </mat-cell>
        </ng-container>

        <!-- date sent Column -->
        <ng-container matColumnDef="date_sent">
          <mat-header-cell *matHeaderCellDef>
            Envio
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div>
              <div *ngIf='element.date_sent'>
                {{ element.date_sent | date: 'dd/MM/yyyy' }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <!-- date response Column -->
        <ng-container matColumnDef="date_response">
          <mat-header-cell *matHeaderCellDef>
            Resposta
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div>
              <div *ngIf='element.date_response'>
                {{ element.date_response | date: 'dd/MM/yyyy' }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <!-- accept Column -->
        <ng-container matColumnDef="accept">
          <mat-header-cell *matHeaderCellDef>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">

            <div *ngIf='!element.accept && element.date_response'
              style='background-color: red; width:10px; height: 10px; border-radius: 50%;'>
            </div>

            <div *ngIf='element.accept && element.date_response'
              style='background-color: rgb(46, 194, 46); width:10px; height: 10px; border-radius: 50%;'>
            </div>

          </mat-cell>
        </ng-container>

        <!-- delete Column -->
        <ng-container matColumnDef="delete">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">

            <a *ngIf='element.date_sent' mat-button (click)='deleteInvite(element)'
              style='background-color: whitesmoke;'>
              <mat-icon class='icon-delete'>delete_outline
              </mat-icon>
            </a>

          </mat-cell>
        </ng-container>

        <!-- select Column -->
        <ng-container matColumnDef="select">

          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)='changeAllLetters($event)' color='primary'></mat-checkbox>
          </mat-header-cell>

          <mat-cell *matCellDef="let element">
            <div *ngIf='!element.date_sent'>
              <mat-checkbox color='primary' [(ngModel)]="element.selected"></mat-checkbox>
            </div>
          </mat-cell>

        </ng-container>

        <!-- edit Column -->
        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a mat-button (click)='openInviteDialog(element)' style='background-color: whitesmoke;'>
              <mat-icon class='icon-info'>
                info_outline
              </mat-icon>
            </a>
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="_inviteSpeakersService.invitesDisplayColumns; sticky: true;"></mat-header-row>

        <!-- Row -->
        <mat-row *matRowDef="let row; columns: _inviteSpeakersService.invitesDisplayColumns;"></mat-row>

      </mat-table>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='makeShipping()'>
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>mark_email_read</mat-icon>
        <div style='color:rgb(43,54,123)'>Respostas</div>
      </ng-template>

      <mat-table class="mat-table-letter"  [dataSource]="_inviteSpeakersService.responsesDataSource" matSort matSortDisableClear='true'>

        <!-- member name Column -->
        <ng-container matColumnDef="member_name_response">
          <mat-header-cell *matHeaderCellDef>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class='letter'>

              <div style='padding: 5px 5px 5px 0;'>
                <div>
                  <a mat-button (click)="openMemberDataDialog(element)" style="color:rgba(0,0,0,.6);">
                    <b>
                      {{ element.name }}
                    </b>
                  </a>
                </div>

              </div>

              <ul *ngFor="let letter of element.letters" style="margin-left:20px;">
                <li>
                  <div style="width: 100%; display:flex; flex-direction: row; justify-content: space-between;">
                    <div>
                      <span>{{letter.letter_name}}</span>
                      <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="0"'> - Confirmação</span>
                      <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="1"'> - Atualização</span>

                      <div *ngIf='letter.obs' style='padding:5px;'>
                        OBS: {{letter.obs}}
                      </div>
                      <div *ngIf='letter.date_sent'>
                        <div style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                          Enviado: {{letter.date_sent.seconds*1000 | date: 'dd/MM/yyyy'}}
                        </div>
                      </div>
                      <div *ngIf='letter.date_response'>
                        <div *ngIf='!letter.accept && letter.date_response'
                          style='padding: 0 10px 0 10px; margin: 5px; width: 160px;'>
                          <img src='assets/images/status/img_red.png'>
                          Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf='letter.accept && letter.date_response'
                          style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                          <img src='assets/images/status/img_green.png'>
                          Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf='letter.accept && letter.date_response && letter.publishSlides'
                          style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                          <img src='assets/images/status/img_green.png'>
                          Publicar slides.
                        </div>
                        <div *ngIf='letter.accept && letter.date_response && !letter.publishSlides'
                          style='padding: 0 10px 0 10px;  margin: 5px; width: 260px;'>
                          <img src='assets/images/status/img_red.png'>
                          Não publicar slides.
                        </div>
                      </div>
                    </div>
                    <div>
                      <a mat-button (click)='archiveItem(letter)' style='background-color: whitesmoke;'>
                        <mat-icon class="icon-info">
                          info_outline
                        </mat-icon>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>

            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef>
            <a mat-button (click)='loadResponses()' style='background-color: whitesmoke;'>
              <mat-icon class='icon-done'>refresh</mat-icon>
            </a>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="_inviteSpeakersService.reponsesDisplayColumns; sticky: true;"></mat-header-row>

        <!-- Row -->
        <mat-row *matRowDef="let row; columns: _inviteSpeakersService.reponsesDisplayColumns;"></mat-row>

      </mat-table>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>insert_drive_file</mat-icon>
        <div style='color:rgb(43,54,123)'>Arquivo</div>
      </ng-template>

      <mat-table class="mat-table-letter" [dataSource]="_inviteSpeakersService.responsesArchivedDataSource" matSort matSortDisableClear='true'>

        <!-- member name Column -->
        <ng-container matColumnDef="member_name_response">
          <mat-header-cell *matHeaderCellDef>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">

            <div class='letter'>

              <div style='padding: 5px 5px 5px 0;'>
                <div>
                  <a mat-button (click)="openMemberDataDialog(element)" style="color:rgba(0,0,0,.6);">
                    <b>
                      {{ element.name }}
                    </b>
                  </a>
                </div>

                <!--
                    <div>
                      <a [href]='element.url_update' target="_blank" style="color:rgba(0,0,0,.6);">
                        <b>
                          {{ element.name }}
                        </b>
                      </a>
                    </div>
                    -->

              </div>

              <ul *ngFor="let letter of element.letters" style="margin-left:20px;">
                <li>
                  <div style="width: 100%; display:flex; flex-direction: row; justify-content: space-between;">
                    <div>
                      <span>{{letter.letter_name}}</span>
                      <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="0"'> - Confirmação</span>
                      <span style='color:rgba(0,0,0,.7);' *ngIf='letter.type=="1"'> - Atualização</span>

                      <div *ngIf='letter.obs' style='padding:5px;'>
                        OBS: {{letter.obs}}
                      </div>
                      <div *ngIf='letter.date_sent'>
                        <div style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                          Enviado: {{letter.date_sent.seconds*1000 | date: 'dd/MM/yyyy'}}
                        </div>
                      </div>
                      <div *ngIf='letter.date_response'>
                        <div *ngIf='!letter.accept && letter.date_response'
                          style='padding: 0 10px 0 10px; margin: 5px; width: 160px;'>
                          <img src='assets/images/status/img_red.png'>
                          Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf='letter.accept && letter.date_response'
                          style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                          <img src='assets/images/status/img_green.png'>
                          Resposta: {{letter.date_response.seconds*1000 | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf='letter.accept && letter.date_response && letter.publishSlides'
                          style='padding: 0 10px 0 10px;  margin: 5px; width: 160px;'>
                          <img src='assets/images/status/img_green.png'>
                          Publicar slides.
                        </div>
                        <div *ngIf='letter.accept && letter.date_response && !letter.publishSlides'
                          style='padding: 0 10px 0 10px;  margin: 5px; width: 260px;'>
                          <img src='assets/images/status/img_red.png'>
                          Não publicar slides.
                        </div>
                      </div>
                    </div>
                    <div>
                      <a mat-button (click)='archiveItem(letter)' style='background-color: whitesmoke;'>
                        <mat-icon class="icon-info">
                          info_outline
                        </mat-icon>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>

            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef>
            <a mat-button (click)='loadResponses()' style='background-color: whitesmoke;'>
              <mat-icon class='icon-done'>refresh</mat-icon>
            </a>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="_inviteSpeakersService.reponsesDisplayColumns; sticky: true;"></mat-header-row>

        <!-- Row -->
        <mat-row *matRowDef="let row; columns: _inviteSpeakersService.reponsesDisplayColumns;"></mat-row>

      </mat-table>

    </mat-tab>

  </mat-tab-group>

</div>